var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('alert',{attrs:{"errors":_vm.errors,"css_class":"ma-1"}}),_c('list-table',{staticClass:"mt-12",attrs:{"itemList":_vm.itemList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }